import { FieldOptions, EasyCardField, EasyAccordionField, EasyExpansionPanelField } from '../index';
import { EasyField } from '../baseClasses/easyField';
import { EasyContainer } from '../baseClasses/easyContainer';
import { EasyForm } from '../baseClasses/easyForm'

export class EasyTabField extends EasyContainer {
    controlType = 'tabs';
    form: EasyForm

    constructor(form: EasyForm, options: FieldOptions<any> = {}) {
        super("", options, form, 'tabs');
        this.form = form;
    }

    addTabToTabContainer(header: string, options: FieldOptions<any> = {}): EasyCardField {
        let container = new EasyCardField(header, options, this.form)
        this.addContainer(container)
        return container;
    }
}
